module.exports = __webpack_public_path__ + "img/s5.d73eab60.png";